"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = createLogger;
const tslib_1 = require("tslib");
const nest_winston_1 = require("nest-winston");
const winston = tslib_1.__importStar(require("winston"));
const fs = tslib_1.__importStar(require("fs"));
const path = tslib_1.__importStar(require("path"));
const winston_cloudwatch_1 = tslib_1.__importDefault(require("winston-cloudwatch"));
const environment_1 = require("./environment");
// Custom log formatter
const LoggerFormat = winston.format.printf((info) => {
    return `[Logger] ${info.timestamp} [${info.level}]: ${info.message}`;
});
// CloudWatch configuration
const cloudwatchConfig = {
    logGroupName: environment_1.ENV.LOG_GROUP_NAME,
    logStreamName: `${environment_1.ENV.NODE_ENV}-stream`,
    // awsAccessKeyId: ENV.AWS_ACCESS_KEY_ID,
    // awsSecretKey: ENV.AWS_SECRET_ACCESS_KEY,
    awsRegion: environment_1.ENV.AWS_REGION,
    messageFormatter: ({ level, message, additionalInfo }) => `[${level}] : ${message} Additional Info: ${JSON.stringify(additionalInfo)}}`,
};
// Utility to generate log file paths dynamically
function getLogFilePaths() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const logDir = path.join(process.cwd(), `logs/${year}-${month}-logs`);
    if (!fs.existsSync(logDir)) {
        fs.mkdirSync(logDir, { recursive: true });
    }
    const errorLog = path.join(logDir, `${year}-${month}-${day}-error.log`);
    const systemLog = path.join(logDir, `${year}-${month}-${day}-system.log`);
    return { errorLog, systemLog };
}
function createLogger() {
    const { errorLog, systemLog } = getLogFilePaths();
    const transports = [];
    if ((environment_1.ENV.CONSOLE_LOG ?? 'false') === 'true') {
        transports.push(new winston.transports.Console({
            level: 'silly',
            format: winston.format.combine(winston.format.colorize(), LoggerFormat),
        }));
    }
    if ((environment_1.ENV.FILE_LOG ?? 'false') === 'true') {
        transports.push(new winston.transports.File({ filename: errorLog, level: 'error' }), new winston.transports.File({ filename: systemLog, level: 'silly' }));
    }
    if ((environment_1.ENV.CLOUD_WATCH_LOG ?? 'false') === 'true') {
        transports.push(new winston_cloudwatch_1.default(cloudwatchConfig));
    }
    return nest_winston_1.WinstonModule.createLogger({
        format: winston.format.combine(winston.format.timestamp(), winston.format.json(), LoggerFormat),
        transports,
    });
}
